import { Grid } from '@material-ui/core'
import Button from '@material-ui/core/Button'
import withStyles from '@material-ui/core/styles/withStyles'
import Typography from '@material-ui/core/Typography'
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Link, Route } from 'react-router-dom'
import { bindActionCreators } from 'redux'

import styles from '../../../resources/theme/global'
import { renderRoute } from '../../../util/utils'
import { fetchSupplier } from '../SupplierActions'
import { getSupplierListData } from '../SupplierReducer'

import Edit from './Edit'
import Filter from './Filter'
import List from './List'
import New from './New'

class Supplier extends Component {
  componentDidMount() {
    const { fetchSupplier } = this.props
    fetchSupplier()
  }

  render() {
    const { classes, items, permissions } = this.props

    return (
      <>
        <Grid
          container
          className={classes.pageHead}
          spacing={1}
          alignItems="center"
        >
          <Grid item xs>
            <Typography variant="h4" color="secondary">
              Contatos Financeiros
            </Typography>
          </Grid>
          <Grid item>
            <Filter classes={classes} />
          </Grid>
          <Grid item>
            {renderRoute(['create-supplier'], permissions) && (
              <Button
                color="primary"
                variant="contained"
                component={Link}
                to="/supplier/new"
              >
                <AddCircleOutlineIcon className={classes.btnIcon} /> Cadastrar
              </Button>
            )}
          </Grid>
        </Grid>

        {renderRoute(['create-supplier'], permissions) && (
          <Route path="/supplier/new" component={New} />
        )}

        {renderRoute(['update-supplier'], permissions) && (
          <Route path="/supplier/:id/edit" component={Edit} />
        )}

        <List permissions={permissions} classes={classes} items={items} />
      </>
    )
  }
}

const mapStateToProps = state => ({
  ...getSupplierListData(state),
  permissions: state.auth.permissions || [],
})

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      fetchSupplier,
    },
    dispatch
  )
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(Supplier))
